import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { T } from '@sm/intl';
import { Box } from '@wds/box';
import { ProgressCircle } from '@wds/progress-circle';
import { Typography } from '@wds/typography';
export const COPY = {
  title: {
    id: 'OpenEndedCoding.TrainingInProgress.title',
    defaultMessage: 'Auto-tagging your responses',
    description: '[Type: Header][Vis: med] - training title'
  },
  description: {
    id: 'OpenEndedCoding.TrainingInProgress.description',
    defaultMessage: "We're running your themes and keywords through an extensive set of algorithms to make sure the auto-tags are accurate.",
    description: '[Type: Header][Vis: med] - training description'
  }
};
const useStyles = createUseStyles(theme => {
  return {
    container: {
      maxWidth: '500px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center'
    }
  };
});
const TrainingInProgress = () => {
  const classes = useStyles();
  return _jsxs(Box, {
    className: classes.container,
    children: [_jsx(Box, {
      mb: 3,
      children: _jsx(ProgressCircle, {
        continuous: true,
        size: "lg",
        valueText: "keywords"
      })
    }), _jsx(Box, {
      mb: 4,
      children: _jsx(Typography, {
        component: "h4",
        variant: "sectionTitle",
        children: _jsx(T, {
          desc: COPY.title
        })
      })
    }), _jsx(Box, {
      mb: 1,
      children: _jsx(Typography, {
        component: "span",
        variant: "body",
        children: _jsx(T, {
          desc: COPY.description
        })
      })
    })]
  });
};
export default TrainingInProgress;